import type { AssetSource } from "@scenix/core";

/**
 * How an asset's source reads in the interface (ADR 000037), so the listing
 * and the detail page describe it the same way.
 */
export function sourceLabel(source: AssetSource): string {
  switch (source) {
    case "youtube":
      return "YouTube import";
    case "link":
      return "Link";
    case "generated":
      return "Generated";
    case "upload":
      return "Upload";
  }
}
